module.exports = __webpack_public_path__ + "img/rise_mockup.f0bd23b1.png";